import { useStore, create } from "zustand";

import type { Map } from "mapbox-gl";

interface MapStore {
  map: Map | undefined;
  setMap: (map: Map | undefined) => void;
}

const mapStore = create<MapStore>()((set) => ({
  map: undefined,
  setMap: (map) => set((state) => ({ map })),
}));

function useMapStore(): MapStore;
function useMapStore<T>(
  selector: (state: MapStore) => T,
  equals?: (a: T, b: T) => boolean
): T;
function useMapStore<T>(
  selector?: (state: MapStore) => T,
  equals?: (a: T, b: T) => boolean
) {
  return useStore(mapStore, selector!, equals);
}

export default useMapStore;
